import { useMutation } from "react-query";
import axios from "../axios";
import { LupaPasswordResponse } from "../../constants/types";

const requestResetPassword = async (formData: FormData) => {
    const response = await axios.post<LupaPasswordResponse>(
        "/api/reqgantipass",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
    );
    return response.data;
};

export default function useRequestResetPassword() {
    return useMutation((formData: FormData) => requestResetPassword(formData));
}
